import React from 'react';

const Banner = () => {
    return (
        <div>
            <h1>Velkommen til Matcha og Mocha</h1>
            <p>Nyskapt café-konsept.</p>
            <p> Moderne aktør i Norge! spennende drikkeopplevelse og en lun atmosfære.</p>
        </div>
    );
};

export default Banner;